import { useEffect, useRef } from 'react';
import { View } from 'foundations-components/components/View';
import AISearchContentRecommendations from 'seo-tools-lib/components/AISearchContentRecommendations';
import { jsx as _jsx } from "react/jsx-runtime";
export const AiSearchEngineOptimizationView = ({
  contentId
}) => {
  const ref = useRef(null);
  const highlightAISearch = window.location.search.includes('highlightAISearch');
  useEffect(() => {
    if (ref.current && highlightAISearch) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }, [highlightAISearch]);
  return /*#__PURE__*/_jsx(View, {
    ref: ref,
    children: /*#__PURE__*/_jsx(AISearchContentRecommendations, {
      contentId: contentId
    })
  });
};